// src/pages/user/Hotels/EventsListPage.jsx
import React from 'react';

const EventsListPage = () => {
  return (
    <div>
      <h1>Events List</h1>
      <p>Manage hotel events here.</p>
    </div>
  );
};

export default EventsListPage;
